/**
 * Created by nijin on 18/1/18.
 */

import {
  Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef,
  AfterViewChecked, SimpleChanges
} from '@angular/core';
import {ThingsService} from "../../things.service";
import {Validators, FormGroup, FormBuilder} from "@angular/forms";

@Component({
    selector: 'nuc-connection-list',
    templateUrl: './connection-list.component.html',
    styleUrls:['./connection.scss']
})
export class ConnectionListComponent implements OnInit, OnChanges, AfterViewChecked {
  connections: Array<any> = [];
  copied: boolean;
  copy: Array<boolean> = [];

  public form: FormGroup;

  @Input() defaultSelection;
  @Input() isMobileApp: boolean;
  @Input() isTitleRequired: boolean;
  @Input() isActionButtonVisible?: boolean;

  @Output() onConnectionChange: EventEmitter<any> = new EventEmitter();
  @Output() onLoadingComplete: EventEmitter<any> = new EventEmitter();
  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

    constructor(private thingsService: ThingsService,
                private fb: FormBuilder,
                private cdRef:ChangeDetectorRef) {
      this.buildForm();
    }

    ngOnInit() {
      this.getConnections();
      this.timeOutFunction();
    }

    ngOnChanges(changes: SimpleChanges) {
      if(changes['defaultSelection'] && this.connections.length &&
           changes['defaultSelection']['previousValue'] !== changes['defaultSelection']['currentValue']  ) {
        let selectedConnection = this.connections.filter((con)=>{return con.id === this.defaultSelection.id })[0]
        this.form.controls['connection'].setValue(selectedConnection);
      }
    }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  buildForm() {
    this.form = this.fb.group({
      'connection': ['', [
        Validators.required
      ]
      ]

    })
  }

  getConnections(){
    this.thingsService.getAllConnections()
      .subscribe((connections)=> {
        this.connections = connections.items;
        if(this.defaultSelection) {
          let selectedConnection = this.connections.filter((con)=>{return con.id === this.defaultSelection.id })[0]
          this.form.controls['connection'].setValue(selectedConnection);
          this.selectConnection(selectedConnection, false);
        }

        this.onLoadingComplete.emit(true);

      },
      error => { this.onLoadingComplete.emit(true)});
  }

  timeOutFunction() {
    setInterval(() =>{
      this.copy.forEach((item, index) => this.copy[index] = false);
      this.copied = false;
    }, 5000)
  }

  selectConnection(connection, actionButtonVisible) {
    this.onConnectionChange.emit(connection);
    this.isActionButtonVisible = actionButtonVisible;
  }

  isValid(): boolean {
     return this.form.valid;
  }
  update() {
    this.onUpdate.emit();
  }





}



// WEBPACK FOOTER //
// ./src/app/things/shared/connection-list/connection-list.component.ts